import { useEffect, useState } from "react";
import { LogOut, Search } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/SiteChrome";
import { WeddingFolders } from "@/components/admin/WeddingFolders";
import { StatsGrid, PackagesEditor, RequestsPanel, AuditPanel } from "@/components/admin/AdminPanels";
import CustomersPanel from "@/components/admin/CustomersPanel";
import RentalsAdmin from "@/components/admin/RentalsAdmin";
import EmailSettings from "@/components/admin/EmailSettings";
import PaymentsAdmin from "@/components/admin/PaymentsAdmin";
import AboutPhotoAdmin from "@/components/admin/AboutPhotoAdmin";

export default function AdminDashboard() {
  const { logout, user } = useAuth();
  const [tab, setTab] = useState("weddings");
  const [q, setQ] = useState("");
  const [pkgs, setPkgs] = useState([]);
  useEffect(() => { api.get("/public/packages").then((r) => setPkgs(r.data)); document.title = "Nadzorna plošča porok"; }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2]" data-testid="admin-dashboard">
      <header className="border-b border-[#EADBCE] bg-[#FAF7F2]/90 backdrop-blur sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-4">
          <Logo />
          <div className="relative flex-1 max-w-md mx-auto hidden sm:block">
            <Search size={16} className="absolute left-4 top-3 text-[#968E87]" />
            <input value={q} onChange={(e) => { setQ(e.target.value); setTab("weddings"); }} placeholder="Poišči poroko …" className="h-10 w-full pl-10 pr-4 rounded-full border border-[#DFD5C5] bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[#C5A880]" data-testid="admin-search-input" />
          </div>
          <span className="text-xs text-[#6C6560] hidden md:inline">{user?.email}</span>
          <button onClick={logout} className="text-sm flex items-center gap-2 text-[#6C6560]" data-testid="admin-logout"><LogOut size={16} /> Odjava</button>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <p className="eyebrow">Master administracija</p>
        <h1 className="font-display text-4xl sm:text-5xl font-light mt-2 mb-8">Nadzorna plošča porok</h1>
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="bg-[#F3ECE1] rounded-full p-1 h-auto flex-wrap justify-start">
            {[["weddings", "Poroke"], ["payments", "Nakazila"], ["customers", "Stranke"], ["rentals", "Najem opreme"], ["stats", "Statistika"], ["requests", "Zahteve in sporočila"], ["packages", "Paketi, cene in O naju"], ["email", "E-poštne nastavitve"], ["audit", "Revizijski dnevnik"]].map(([v, l]) => (
              <TabsTrigger key={v} value={v} className="rounded-full px-4 py-2 data-[state=active]:bg-[#231F20] data-[state=active]:text-white" data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>
            ))}
          </TabsList>
          <TabsContent value="weddings" className="mt-6"><WeddingFolders q={q} setQ={setQ} pkgs={pkgs} /></TabsContent>
          <TabsContent value="stats" className="mt-6"><StatsGrid /></TabsContent>
          <TabsContent value="customers" className="mt-6"><CustomersPanel /></TabsContent>
          <TabsContent value="rentals" className="mt-6"><RentalsAdmin /></TabsContent>
          <TabsContent value="requests" className="mt-6"><RequestsPanel /></TabsContent>
          <TabsContent value="packages" className="mt-6"><PackagesEditor /><AboutPhotoAdmin /></TabsContent>
          <TabsContent value="payments" className="mt-6"><PaymentsAdmin /></TabsContent>
          <TabsContent value="email" className="mt-6"><EmailSettings /></TabsContent>
          <TabsContent value="audit" className="mt-6"><AuditPanel /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
